/** Suggested search radius (km) per place granularity, as Google Places reports it. */
export const SUGGESTED_RADIUS_KM = {
    city: 25,
    province: 50,
    gewest: 75,
} as const;
